(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["AA-guide-theme-1"]) return;
  try {
    
(function () {
  function runDemo(btn, result) {
    if (!window.ButtonFeedback) return;
    btn.style.minWidth = btn.offsetWidth + 'px';
    window.ButtonFeedback.loading(btn);
    setTimeout(function () {
      if (result === 'error') {
        window.ButtonFeedback.error(btn);
      } else {
        window.ButtonFeedback.success(btn);
      }
    }, 1500);
  }

  document.querySelectorAll('[data-guide-demo-success]').forEach(function (btn) {
    btn.addEventListener('click', function () { runDemo(btn, 'success'); });
  });

  document.querySelectorAll('[data-guide-demo-error]').forEach(function (btn) {
    btn.addEventListener('click', function () { runDemo(btn, 'error'); });
  });

  document.querySelectorAll('[data-guide-demo-custom]').forEach(function (btn) {
    btn.addEventListener('click', function () { runDemo(btn, 'success'); });
  });

  document.querySelectorAll('[data-copy-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pre = btn.previousElementSibling;
      navigator.clipboard.writeText(pre.textContent.trim()).then(function () {
        var original = btn.textContent;
        btn.textContent = 'Copiado!';
        setTimeout(function () { btn.textContent = original; }, 1500);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["AA-guide-theme-2"]) return;
  try {
    
(function () {
  document.querySelectorAll('[data-copy-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pre = btn.previousElementSibling;
      navigator.clipboard.writeText(pre.textContent.trim()).then(function () {
        var original = btn.textContent;
        btn.textContent = 'Copiado!';
        setTimeout(function () { btn.textContent = original; }, 1500);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var threshold = window.cartDrawerConfig?.freeShippingThreshold || 0;
    var notification = document.querySelector('[data-cart-notification]');
    var hideTimer = null;

    function formatMoney(cents) {
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    function showNotification(cartTotal) {
      if (!notification) return;
      if (threshold > 0) {
        var bar = notification.querySelector('[data-notification-bar]');
        var remainingEl = notification.querySelector('[data-notification-remaining]');
        var textEl = notification.querySelector('[data-notification-shipping-text]');
        var remaining = Math.max(0, threshold - cartTotal);
        var progress = Math.min(100, (cartTotal / threshold) * 100);
        if (bar) bar.style.width = progress + '%';
        if (remaining === 0) {
          if (textEl) textEl.innerHTML = '<strong>Você alcançou o frete grátis!</strong>';
        } else {
          if (remainingEl) remainingEl.textContent = formatMoney(remaining);
        }
      }
      notification.removeAttribute('hidden');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        notification.setAttribute('hidden', '');
      }, 4000);
    }

    var closeBtn = notification?.querySelector('[data-close-cart-notification]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        notification.setAttribute('hidden', '');
        clearTimeout(hideTimer);
      });
    }

    document.addEventListener('cart:added', function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { showNotification(cart.total_price); })
        .catch(function () { showNotification(0); });
    });

    // Upsell add to cart
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-upsell-add]');
      if (!btn) return;
      if (btn.closest('[data-upsell-dragging]')) return;
      var variantId = btn.dataset.upsellAdd;
      if (variantId) window.CartManager?.add(variantId, { button: btn, action: 'open_drawer' });
    });

    // Upsell click protection after drag is handled by the inline script above
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var nav = document.querySelector('[data-header-nav]');
    if (!nav) return;

    var navContainer = nav.parentElement;
    var triggers = nav.querySelectorAll('[data-nav-trigger]');
    var openMenu = null;

    function closeAll() {
      navContainer.querySelectorAll('[data-nav-menu]').forEach(function(m) {
        m.classList.add('hidden');
      });
      openMenu = null;
    }

    triggers.forEach(function(trigger) {
      var handle = trigger.getAttribute('data-nav-trigger');
      var menu = navContainer.querySelector('[data-nav-menu="' + handle + '"]');
      if (!menu) return;

      trigger.addEventListener('mouseenter', function() {
        if (openMenu && openMenu !== menu) {
          openMenu.classList.add('hidden');
        }
        menu.classList.remove('hidden');
        openMenu = menu;
      });

      trigger.addEventListener('focus', function() {
        closeAll();
        menu.classList.remove('hidden');
        openMenu = menu;
      });
    });

    nav.querySelectorAll('a:not([data-nav-trigger])').forEach(function(link) {
      link.addEventListener('mouseenter', closeAll);
    });

    navContainer.addEventListener('mouseleave', closeAll);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeAll();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
